import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";


function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col className="home-about-description text-center">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I fell in love with programming and I have at least learnt
              something, I think… &nbsp; : )
           
              <br />I am fluent in &nbsp;
              <p>
                
              &nbsp; &nbsp; &nbsp;&nbsp;&nbsp;  <b className="purple">HTML, CSS, Boostrap, Javascript, React.js . </b>
              </p>
           
              <br />I am Comfortable in 
              <p>
              &nbsp; &nbsp; &nbsp;&nbsp;&nbsp; <b className="purple">Firebase,Sass, node.js express.js mongodb(CRUD), Meterail Ui, react-boostrap, Heroku, netlify, git  . </b>
              </p>
              <br />
              <br />I am familiar in 
              <p>
              &nbsp; &nbsp; &nbsp;&nbsp;&nbsp; <b className="purple">Next.js, Redux </b>
              </p>
              <br />
              My current focus is on &nbsp;
              <p>
              &nbsp; &nbsp; &nbsp;&nbsp;&nbsp; <b className="purple">
                 Become a world Class Web developer.
                </b>
              </p>
              <br/>
              I Like to apply my passion for developing products
              with
              <p>
              &nbsp; &nbsp; &nbsp;&nbsp;&nbsp;  <b className="purple"> Modern Javascript Frameworks</b>
              </p>
                &nbsp; like
              <b>
                <b className="purple"> React.js</b>
              </b>
            </p>
          </Col>
          
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/Raihanuddin-anik"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <i className="fab fa-github"></i>
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://twitter.com/RaihanB01308271"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <i className="fab fa-twitter"></i>
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/raihan-bhuiyan-3850ba1ba/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <i className="fab fa-linkedin-in"></i>
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/raihan_a.bhuiyan/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <i className="fab fa-instagram"></i>
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
